//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import Comment from "./../../elements/Comment";
	import { EventBus } from './../../../events.js';
	import Loader from "../../loaders/Loader";
    import { Mentionable } from 'vue-mention';

    import EmojiPicker from 'vue-emoji-picker';

    import Echo from 'laravel-echo'

	export default {
		name: "article-comments",
		components: {Loader, Comment, EmojiPicker, Mentionable},
    props: {
      enableCommentsButton: {
        type: Boolean,
        default: true
      },
      showAllCommentsButton: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'article'
      }
    },
		//props: ['id', 'type', 'showAllComments'],
		data() {
			return {
				loader: false,
				comments: [],
        visibleComment: null,
        mentions: [],
				order: 'latest',
				form: new window.Form({
					body: '',
					article_id: '',
          parent_id: null,
          game_id: '',
				}),
        searchEmoji: '',
				likedComments: JSON.parse(localStorage.getItem('liked_comments') || '[]'),
        commentInProgress: false,
        commentsType: 'default',
        isPremium: false,
        isStaff: false,
        countUsers: 0,
        canUseComments: true,
        showAllComments: this.showAllCommentsButton,
        allCommentsLoaded: false,
			}
		},
		created() {
			this.loader = true;
			this.loadComments();
			this.loadMentions();

            setTimeout(() => {
                this.isPremium = this.$root.user.isPremium;
                this.isStaff = this.$root.user.isStaff;


                if( this.commentsType === 'live' ) {
                    new Echo({
                        broadcaster: 'pusher',
                        key: process.env.MIX_PUSHER_APP_KEY,
                        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                        encrypted: true,
                        forceTLS: true,
                        auth: {
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        }
                    }).join('live_comments')
                        .here((users) => {
                            this.countUsers = users.length;
                        })
                        .here((users) => {
                            this.countUsers = users.length;
                        })
                        .joining((user) => {
                            this.countUsers++;
                        })
                        .leaving((user) => {
                            this.countUsers--;
                        })
                        .listen('.comment.posted', (e) => {
                            //console.log(e);
                            this.comments.unshift(e.comment);
                        })
                        .listen('.comment.moderated', (e) => {
                            if( e.comment.validation < 1 ) {
                                this.comments[e.index].body = '[Commentaire modéré]';
                                if( e.comment.user_id === this.$root.user.id ) {
                                    window.Notify.warning('Votre commentaire a été modéré par notre équipe de modération');
                                }
                            } else {
                                this.comments[e.index].body = e.comment.body;
                                if( e.comment.user_id === this.$root.user.id ) {
                                    window.Notify.warning('Votre commentaire vient d\'être rétabli par notre équipe de modération.');
                                }
                            }
                        });
                }
            }, 1000);

		},
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                },
            },
        },
		watch: {
			likedComments: {
				handler: function(likedComments) {
					localStorage.setItem('liked_comments', JSON.stringify(likedComments));
				}
			}
		},
		mounted() {

			EventBus.$on('deleted', data => {
				this.comments.splice(data.index, 1);
			});

			EventBus.$on('commentAnswered', data => {
				this.comments.splice(data.index + 1, 0, data.comment);
            });

			EventBus.$on('liked', (data) => {
				let index = data.index;
				let comment = data.comment;

				let cookie = null;
				if( this.likedComments.length > 0 ) {
					Object.keys(this.likedComments).forEach(key => {
						if( parseInt(this.likedComments[key]['id']) === comment.id) {
							cookie = this.likedComments[key]['cookie'];
						}
					});
				}

				window.Api.get('comments/' + comment.id + '/like' + (cookie ? '?cookie=' + cookie : '')).then(response => {
					if( response.success ) {
						if( response.data.action === 'increment' ) {
							comment.likes++;
						} else {
							comment.likes--;
						}

						let entry = {id: response.data.comment, cookie: response.data.cookie};
						if( this.likedComments.length > 0 ) {
							let insert = true;
							Object.keys(this.likedComments).forEach(key => {
								if( parseInt(this.likedComments[key]['id']) === response.data.comment || this.likedComments[key]['cookie'] === response.data.cookie ) {
									insert = false;
								}
							});

							if( insert ) {
								this.likedComments.push(entry);
							}

						} else {
							this.likedComments.push(entry);
						}
					} else {
						if( response.message ) {
							window.Notify.error(response.message);
						}
					}
				});
			});
		},
		methods: {
      toggleShowAllComments() {
        this.showAllComments = true;
      },
			loadComments() {
				try {
				    let url = this.type === 'article' ? 'articles/article/' + this.id : 'rugby/game/' + this.id;
					window.Api.get(url + '/comments?order=' + this.order).then(response => {
						let comments = response.data.comments;
						comments.forEach((comment) => {
              if( this.visibleComment == null ) {
                this.visibleComment = comment;
              }
              this.comments.push(comment);
            });
            this.allCommentsLoaded = true;
						this.loader = false;
                        this.commentsType = response.data.comments_type;
                        if( this.commentsType === 'live' ) {
                            this.canUseComments = response.data.can_use_comments;
                        }

                        setTimeout(() => {
                            if( this.commentsType === 'default' && response.data.is_premium ) {
                                if( !this.isPremium && !this.isStaff  ) {
                                    this.canUseComments = false;
                                }
                            }
                        }, 1000);

						this.goToComment();
					});
				} catch(e) {
					console.log(e);
				}
			},

            loadMentions() {
			    try {
			        window.Api.get('comments/' + this.id + '/users/' + this.type).then((response) => {
			            this.mentions = response.data.users;
                    });
                } catch(e) {
                    console.log(e);
                }
            },

            appendEmoji(emoji) {
                this.form.body += ' ' + emoji;
            },

            translate(str) {
			    str = str.replace('Frequently used', 'Fréquemment utilisés');
			    str = str.replace('People', 'Personnes');
			    str = str.replace('Objects', 'Objets');
			    str = str.replace('Places', 'Lieux');
			    str = str.replace('Symbols', 'Symboles');
			    return str;
            },

			sortComments(order) {
				this.order = order;
				this.loader = true;
				this.comments = [];
				this.loadComments();
				//this.comments = _.orderBy(this.comments, ['created.date'], [order]);
			},

			onSubmit() {
        if( this.type === 'article' ){
            this.form.article_id = this.id;
        } else {
          this.form.game_id = this.id;
        }

        this.commentInProgress = true;
				this.form.post('api/comments').then(response => {
					if( response.success ) {
						let comment = response.data.comment;
						if( this.order === 'latest' ) {
						    setTimeout(() => {
						      if( comment !== null ) {
                    this.comments.unshift(response.data.comment);
                  }
                }, 500);
							//this.comments.splice(0, 1, comment);
						} else {
						  if( comment !== null ) {
                this.comments.push(comment);
              }
						}
            if( response.message ) {
              window.Notify.success(response.message);
            }

						this.form.reset();
					} else {
						window.Notify.error(response.message);
					}
					this.commentInProgress = !this.commentInProgress;
				});
			},

            onPressEnter() {
			    if( this.commentsType === 'live' ) {
			        return this.onSubmit();
                }

			    return null;
            },

            onKeyDown() {
			    this.form.errors.clear();
                this.commentInProgress = false;
            },

            goToComment() {
				let url = new URL(window.location.href);
				let comment = url.searchParams.get("comment");
				if( comment ) {
					window.Notify.success('Vous allez être positionné sur le commentaire.');
					setTimeout(() => {
						document.querySelector('#comment_' + comment).scrollIntoView({
							behavior: 'smooth'
						});
					}, 2000);
				}
            },
		},
	}
